import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuditoriaEntidadDto } from '@models/auditoria/auditoriaEntidadDto.model';
import { AuditoriaService } from '@services/auditoria/auditoria.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HistorialCambioDialogComponent } from '@views/historial-cambio/historial-cambio-dialog.component';

/**
 * Bloque de "Información de auditoría" reutilizable.
 *
 * Se suma a cualquier pantalla con una línea:
 *
 *   <app-info-auditoria entidad="Movimientos" [id]="movimientoDetailDto.id"></app-info-auditoria>
 *
 * La entidad es el nombre de la TABLA, no el de la pantalla: tiene que coincidir
 * exactamente con el que usa HistorialCambios, si no el historial sale vacío.
 */
@Component({
  selector: 'app-info-auditoria',
  templateUrl: './info-auditoria.component.html',
  styleUrls: ['./info-auditoria.component.css']
})
export class InfoAuditoriaComponent implements OnChanges {

  /** Nombre de la tabla: Movimientos, Contratos, Comprobantes, ... */
  @Input() entidad!: string

  @Input() id!: number

  /** Permite ocultar el botón de historial donde no corresponda */
  @Input() mostrarHistorial: boolean = true

  /** Sin tarjeta ni título: sólo los datos. Para meterlo dentro de otra card. */
  @Input() sinTarjeta: boolean = false

  auditoria?: AuditoriaEntidadDto
  cargando = false
  fallo = false

  constructor(
    private auditoriaService: AuditoriaService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog
  ) { }

  /**
   * ngOnChanges y no ngOnInit: el id suele llegar después del primer render,
   * cuando el padre todavía está esperando su propio GET.
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes['id'] || changes['entidad'])
      this.cargar()
  }

  private cargar() {
    if (!this.entidad || !this.id || this.id <= 0) {
      this.auditoria = undefined
      return
    }

    this.cargando = true
    this.fallo = false
    this.spinner.show("spAuditoria")

    this.auditoriaService.getAuditoriaEntidad(this.entidad, this.id)
      .subscribe(
        data => {
          this.spinner.hide("spAuditoria")
          this.auditoria = data
          this.cargando = false
        },
        () => {
          // Sin snackbar: que falle la auditoría no puede tapar la pantalla con
          // un error rojo. Se muestra un texto discreto y listo.
          this.spinner.hide("spAuditoria")
          this.fallo = true
          this.cargando = false
        }
      )
  }

  abrirHistorial() {
    if (!this.auditoria)
      return

    this.dialog.open(HistorialCambioDialogComponent, {
      width: '90%',
      data: {
        idEntidad: this.auditoria.idEntidad,
        nombreEntidad: this.auditoria.nombreEntidad
      },
      panelClass: 'historial-dialog-panel',
      disableClose: false
    })
  }

  /** Los registros anteriores a la auditoría no tienen usuario: se dice, no se inventa. */
  textoUsuario(nombre?: string, fecha?: Date): string {
    if (nombre)
      return nombre

    return fecha ? 'Usuario no registrado' : '-'
  }
}
